<template>
  <div class="collection-page--main-wrapper product-desc">
    <top-header></top-header>

    <div class="collection-page--outer-wrapper mtcat" >
      <div class="collections-page--header-wrapper">
        
		
		<b-container v-if="catBanner!=''">
          <!-- <b-breadcrumb
            :items="breadcrumbItems"
            class="breadcrumb--page"></b-breadcrumb> -->
          <b-img style="width:100%"
            :src="$root.MEDIAPATH+'category-banner/'+catBanner+'.jpg' || ''"
            alt=""
            class="collection-page-feature-banner collection-page-feature-banner--cosmetics"
          ></b-img>
        </b-container>
		<b-container>
          <b-breadcrumb
            :items="breadcrumbItems"
            class="breadcrumb--page"></b-breadcrumb>
			  <b-breadcrumb  v-if="myaccountUrl!=''" class="breadcrumb--page" style="float:right;margin: 1px;">
				<b-breadcrumb-item :href="myaccountUrl">
				   <em style="font-size: 21px;" ><b-icon class="py-0 " icon="person" aria-hidden="true"  ></b-icon></em>
				  My Account
				</b-breadcrumb-item>
			  </b-breadcrumb>
        </b-container>
		
      </div>
		<b-container class="py-0 pb-2 filter d-none d-md-block">
			<b-row class="d-flex align-items-center justify-content-between">
			  <b-col lg="3" md="3" sm="12">
				FILTERS
			  </b-col> 
			  
			  <b-col lg="6" md="6" sm="12" class="pl-0">
				<div class="d-flex align-items-left">
				<span>{{category_name}} ({{totalProduct|0}})</span>
				
			  </div>
			  </b-col>
			  
			  
			  <b-col >
				<div
				  class="d-flex align-items-center justify-content-between"	>
				  <span>
				  Sort By:
				</span>
				<span>
				  <b-form-select
					class="forms ml-2"
					v-model="sortby"
					:options="optionsSort"
					@change="applyShorting"
				  ></b-form-select>
				  </span>
				</div>
			  </b-col>
			</b-row>
		  </b-container>
      <b-container>
			

        <!--<span class="product-txt d-block text-center ">All Products</span> -->
		
        <b-row class="borderTop">
          <b-col cols="12" lg="3" md="3" sm="12" class="filterPael">
            <div class="product-filter--outer-wrapper nav mobilfilter" id="filterlist" :class="[{'mobilfilterlist' : mobilfilterlist}]">
			 <b-container fluid class="d-md-none applyPaneltop">
			  <b-row>
				<b-col cols="6" class="filtebrack">
				<b-link @click="mobilfilterlist=0"><i class="fa fa-angle-left"></i>
				<span>Filters</span></b-link>
				</b-col>
				<b-col class="applyBtn" cols="6">
					<b-link @click="mobilfilterlist=0" class="btnapply"></b-link>
				</b-col>
			   </b-row>
			   </b-container>
			
			
              <div class="product-filter--accordion-wrapper accordion" role="tablist">
                <div v-for="(filterTab, index) in filterTabsOptions" :key="filterTab.label">
                  <div role="tab" @click="filterTab.toggleIcon()">
                    <a href="javascript:void(0)" block
                      class="product-filter--accordion-btn d-flex justify-content-between align-items-center"
                      v-b-toggle="'product-accordion-' + index">
                      <span v-if="filterTab.label=='Gender'" >Ideal For</span>
                      <span v-else>{{ filterTab.label }}</span>
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="18px"
                        height="18px"
                        viewBox="0 0 22.354 22.354"
                        style="enable-background: new 0 0 22.354 22.354"
                        xml:space="preserve"
                        class="accordion-active-icon accordion-active-icon--minus"
                        v-if="filterTab.showMinusSign">
                        <g><rect y="8.61" width="22.354" height="5.133" /></g>
                      </svg>
                      <b-icon icon="plus" class="accordion-active-icon" v-if="!filterTab.showMinusSign"></b-icon>
                    </a>
                  </div>

                  <b-collapse :id="'product-accordion-' + index" v-bind:visible="filterTab.isOpened" :accordion="'product-filter-accordion' + index" role="tabpanel">
                    <!--<b-form-group v-if="filterTab.label=='Price'">
                      <range-slider
                        class="slider"
                        :min="filterTab.filterOptions.min"
                        :max="filterTab.filterOptions.max"
                        step="10"
                        v-model="filterTab.selectedOptions" @change="applyFilter()">
                      </range-slider>
                    </b-form-group> -->
                    <b-form-group>
                      <b-form-checkbox-group
                        :id="'product-filter-checkbox-' +filterTab.label.toLowerCase()"
                        v-model="filterTab.selectedOptions"
                        :options="filterTab.filterOptions"
                        :name="'product-filter-checkbox-' +filterTab.label.toLowerCase()"
                        class="d-flex flex-column pl-2 product-filter-checkbox-group"
                        @input="applyFilter()"></b-form-checkbox-group>  
                    </b-form-group>
					
					
					
                  </b-collapse>
                </div>
              </div>
			  <b-container fluid class="d-md-none applyPanel">
			  <b-row>
				<b-col cols="6">
				&nbsp;
				</b-col>
				<b-col class="applyBtn" cols="6">
					<b-link @click="mobilfilterlist=0" class="btnapply">Apply</b-link>
					
				</b-col>
			   </b-row>
			   </b-container>
            </div>
          </b-col>


          <b-col cols="12" lg="9" md="9" sm="12" class="pr-0  pl-0 dividerPlist" id="infinite-list" >
			 <transition name="fade">
			  <div class="loading" v-if="showPreloader">
				<span class="fa fa-spinner fa-spin"></span>
			  </div>
			</transition>
		  
				<div class="all-products--wrapper d-flex flex-wrap justify-content-between" v-if="products.length>0" >
				  <div v-for="product in products" :key="product.id"
					class="product--wrapper d-flex flex-column align-items-center">
					<!--<span class="product-title d-block"><a :href="'/product/'+product.product_id">{{product.title}}</a></span> -->
					<!--<product-offer :offer="true" :product="product"></product-offer> -->
					
					<div class="product--img-wrapper imgcatOrg">
					
					
					
					<a v-if="product.product_slug==null" :href="'/product/'+product.product_id">
					  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
						:src="$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+product.image"
						:alt="product.title" ></b-img-lazy>
					
					  </a>
					  <a v-else :href="'/'+product.product_slug">
					  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
						:src="$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+product.image"
						:alt="product.title" ></b-img-lazy>
					
					  </a>
					</div>
					<!--<product-offer-20 :offer="true" :product="product"></product-offer-20> -->
					
					<cateoryimage-slider v-if="product.product_slug==null"   :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/product/'+product.product_id" class="d-none d-md-block" ></cateoryimage-slider>
					<cateoryimage-slider v-else :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/'+product.product_slug" class="d-none d-md-block" ></cateoryimage-slider> 
					
					
					
					<addtocart-button :productData="product" :pagecategory="true" class="d-none d-md-block"></addtocart-button> 
					
					<div class="pl-2 pr-2 w-100 ptitleDetail">
						<h4  class="text-truncate m-0"><b-link :href="'/brand/'+product.brand.replace(/ /g,'-')" >{{product.brand}} </b-link></h4>
						<h5 class="text-truncate m-0"> 
						<b-link v-if="product.product_slug==null" :href="'/product/'+product.product_id" class="product-title text-capitalize">{{product.title}}</b-link>
						<b-link v-else :href="'/'+product.product_slug" class="product-title text-capitalize">{{product.title}}</b-link>
						
						</h5>
					</div>
					
				  
					<product-price :category="true" :product="product"></product-price>
					<!--<product-rating :userrating="product.total_rating"></product-rating> -->
					<product-commision :category="true" :product="product" :myroleId="myroleId"></product-commision>
					
					<addtocart-button :productData="product" :pagecategory="true" class="d-md-none"></addtocart-button> 
				   
				  </div>
				  
				  <div v-if="products.length%3>0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center" style="width: 255px;">
					</div>
				</div>
			 
			  <div class="all-products--wrapper d-flex flex-wrap justify-content-between" v-else>
				
				<div class="product--wrapperno d-flex flex-column align-items-center" v-if="showPreloader==false">
                <span class="product-title d-block">Our Product Catalogue is being updated daily. Please check back later.</span>
				</div>
			  
			  
			  </div>
			 
			 <!--<b-container v-if="allowInfinite=='false'">
				<p class="text-center" >No More Products to Show</p>
			 </b-container >-->
			 <!-- <b-button type="button" pill class="btn--load-more" v-if="nextPage" @click="loadMore()">Load More </b-button> -->
			 
			 
			 <b-container v-if="thisisweb==1 && totalProduct>0">
		   
				<b-pagination v-model="currentPage" pills :total-rows="totalProduct" size="sm" @change="handlePageChange" align="center" per-page="12" limit="10"></b-pagination>
			 </b-container>
		
			 
          </b-col>
        </b-row>
      </b-container>
    </div>
		<!-- ------------ Filter Footer --------------- -->
		<b-container class="mt-2 d-md-none"></b-container>
		<b-container fluid class="filterTab d-md-none">
		<b-row>
				<b-col 	cols="6" class="p-0 b-r-1px">
					<div class="segment-1">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="579yu3ce3a" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#579yu3ce3a)" transform="translate(-45 -685) translate(0 672)"><g><g><g><g><path d="M5.05 13.551V2.224c0-.373-.307-.68-.679-.68-.372 0-.68.307-.68.68V13.55l-2.513-2.834c-.272-.271-.68-.307-.95-.069-.272.271-.308.68-.07.95l3.704 4.144c.277.343.97.29 1.188 0v-2.19zM12.074 4.398L8.404.255c-.327-.33-.937-.35-1.221 0V13.74c0 .373.307.68.679.68.372 0 .679-.271.679-.647V2.45l2.514 2.834c.271.271.68.307.95.069.271-.274.307-.683.069-.954z" transform="translate(33 6) translate(12) translate(0 7) translate(6 4)"></path></g></g></g></g></g></g></g></svg> Sort By
					
					</div>
				
				</b-col>
				<b-col cols="6" >
					<div class="segment2">
						
						<b-link @click="mobilfilterlist=1">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="565v74wosa" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#565v74wosa)" transform="translate(-207 -685) translate(0 672)"><g><g><g><path d="M18.533 5c.567 0 1.028.46 1.028 1.028 0 .247-.089.485-.25.672l-4.98 5.773v5.193c0 .332-.16.643-.43.836L11.9 19.935c-.462.33-1.104.224-1.435-.237-.125-.175-.192-.384-.192-.599v-6.625l-5.02-5.771c-.372-.429-.327-1.078.101-1.45C5.541 5.09 5.78 5 6.028 5h12.505zm-5.468 7.841h-1.528v5.797l1.528-1.094V12.84zm4.95-6.576H6.548l4.688 5.39h2.127l4.65-5.39z" transform="translate(195 6) translate(12) translate(0 7)"></path></g></g></g></g></g></g></svg>
						Filter </b-link>
						
						</div>
				</b-col>
		</b-row>
		</b-container>
		<!-- --------------------- -->
		<share-popup :cartItems="$root.share.shopshareitems"  :cartData="$root.share.shopshareitems" :cartTotalqty="$root.share.shopshareitems.length" :productAll="$root.share.recommended"></share-popup>
    <!--<top-footer></top-footer> -->
  </div>
</template>

<script>
import Header from "@/components/header.vue";
//import Footer from "@/components/footer.vue";
//import ProductRating from "@/components/product-rating.vue";
import ProductPrice from "@/components/product-price.vue";
import ProductCommision from "@/components/product-commision.vue";
//import ProductOffer from "@/components/product-offer.vue";
//import ProductOffer20 from "@/components/product-offer-20.vue";
import AddtocartButton from "@/components/addtocartButton.vue";
import CateoryimageSlider from "@/components/cateoryimageSlider.vue";
import SharePopup from "@/components/agent/share-popup.vue";
//import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style
import '../assets/category.scss';
import 'vue-range-slider/dist/vue-range-slider.css';
export default {
  name: "collection-page-cosmetics",
  
	props: {
    WEBURL: { type: String },
		metadata: { type: Object },
	},
	
	beforeCreate: function () {
    document.body.className = "collection-page-cosmetics";
  }, 
   watch: {
      '$route' (to, from) {
		console.log('to'+to.path+'--from-'+from);
		if (to.path) {
			//this.refressAllVariable();
			//this.initload();
			 window.location.reload();
			 //this.$forceUpdate();
		
		}
        /* if (to.path === '/promotions') {
          this.$store.dispatch('getAllPromotions')
        } else if (to.path === '/promotions/coupon') {
          this.$store.dispatch('getAllPromotions', {
            type: 'coupon'
          })
        }*/
      }
    },
  components: {
    "top-header": Header,
   // "top-footer": Footer,
    //"product-rating": ProductRating,
    "product-price": ProductPrice,
    "product-commision": ProductCommision,
   //"product-offer": ProductOffer,
    //"product-offer-20": ProductOffer20,
    "addtocart-button": AddtocartButton,
    "cateoryimage-slider": CateoryimageSlider,
	"share-popup": SharePopup,
    /*RangeSlider,*/
  },
  mounted(){
		//this.initload();
		this.accesskey=this.$root.customer_info.access_key;
		var categieyName = this.$route.params.category;
		//console.log('sss'+this.banerCategory[categieyName]);
		this.catBanner = '';
		if(this.banerCategory[categieyName]==1){
		this.catBanner = categieyName;
		}
		
		this.breadcrumbItems= [
			{
			  text: "Home",
			  href: "/",
			},
			{
			  text: "Trending Products",
			  active: true,
			},
		  ];
		  
		// Initially load some items.
	  
		
		this.loadmoredata();
	  /* ============Sticky LeftPanel===============*/
	  this.$nextTick(function(){
        window.addEventListener("scroll", function(){
          var navbar = document.getElementById("filterlist")
          var nav_classes = navbar.classList
          if(document.documentElement.scrollTop >= 150) {
            if (nav_classes.contains("shrink") === false) {
              nav_classes.toggle("shrink");
            }
			
          }
          else {
            if (nav_classes.contains("shrink") === true) {
              nav_classes.toggle("shrink");
            }
          }
        })
      })
   
	  /*=========================================*/
	  
	  /* =================Device Width =================== */
		if(window.innerWidth < 700){
			this.thisisweb=0;
			window.addEventListener('scroll', this.handleScroll);
			/* this.phoneImageWidth  = 120;
			this.phoneImageHeight = 120;*/
		 }
	  
	  /* For My account */
	   var roleIdmy =this.$root.customer_info.role;
		  var myaccountReuri=''
		  if(roleIdmy==4){
			myaccountReuri = '/customer/dashboard';
		  }else if(roleIdmy==3){
			myaccountReuri = '/'+this.$root.INFLUENCER+'/dashboard';
		  }else if(roleIdmy==2){
			myaccountReuri = '/seller/dashboard';
		  }else if(roleIdmy==1) {
			myaccountReuri = '/admin/dashboard';
		  }else{
			myaccountReuri ='';
		  }
		  this.myroleId		= roleIdmy;
		  this.myaccountUrl = myaccountReuri;
	  /* ============= */
	},
  data() {
    return {
	mobilfilterlist: 0,
	allowInfinite: true,
	showPreloader: true,
	loading: false,
    nextItem: 1,
	 accesskey:'',
      nextPage:0,
	  paginationData:[],
	  totalProduct:0,
	  currentPage:0, 
	  thisisweb:1,
      catBanner:'fashion',
      pageurl: this.$root.WEBURL+'trendingproducts',
      //pageurl: this.$root.WEBURL+'categoryproductsnew',
      url: this.$root.WEBURL+'relatedproducts',
      urlCreatProductUri: this.$root.WEBURL+'createProductUrlAll',
      pageinfo: {},
      category_info: [],
			category_type: '',
			products: [],
      filterQuery: [],
			totalpages:0,
      product_qty:1,
      breadcrumbItems: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Trending",
          active: true,
        },
      ],
	   myaccountUrl:'',
      priceSliderValue: 0,
      filterTabsOptions: [],
	 thumbnailProps: { blank: false, fluidGrow: true, width: 253, height: 280,class: 'm1' },
	 metaInfoList:{'fashion':{title:"Latest Fashion Trend for Men and Women | Alluraa",
							description:"Find top selling fashion items from clothing to shoes under both men and women categories. Grab great offers and purchase your favorite product."},
					'cosmetics':{title:"Buying Cosmetics Products Online Made Easy | Alluraa",
							description:"Order beauty and cosmetics products online from Alluraa. Foundation, concealer, kajal, lipstick , nail polish, make up kit, mascaras and more at affordable prices."},
					'organic':{title:"Healthy Life with Organic Food & Nutrition | Alluraa",
							description:"Find popular organic nutritional products for your hair and skin care as well as ayurvedic immunity booster online at best prices. Order today at Alluraa."},
					'home-essentials':{title:"Home Essentials Products Every House Needs | Alluraa",
							description:"Order all types of home essentials at best prices in India. From home decor, furniture to kitchen items, everything is available at Alluraa. Visit us and explore more."},
					'indian-crafts':{title:"Reach Out To Indian Handicrafts Online at Alluraa",
							description:"Shop from a wide range of beautiful Indian crafts, ethnic wear, fabrics, home decor, acessories and more at best prices. Check out our latest collections today."},
	 
				 },
		phoneImageWidth:253,
		phoneImageHeight:280,
		myroleId:0,
		discountArry:{'10% & Below':'1-9',
					'10% & Above':'10-19',
					'20% & Above':'20-29',
					'30% & Above':'30-39',
					'40% & Above':'40-49',
					'50% & Above':'50-59',
					'60% & Above':'60-69',
					'70% & Above':'70-79',
					'80% & Above':'80-89',
					'90% & Above':'90-100',
					 },
		 optionsSort: [
			{ value: null, text: "Recommended" },
			{ value: 'new', text: "New Arrivals" },
			{ value: "pricedesc", text: "Price: High to Low" },
			{ value: "priceasc", text: "Price: Low to High" },
			{ value: "disconut", text: "Better Discount" },
			{ value: "rating", text: "Customer Rating" },
		  ],
		  sortby:null,
		  category_name:'',
		  banerCategory:{women:1,men:1,cosmetics:1,'home-essentials':1},
		  
    };
  },
  methods: {	
    setData (err, post) {
			if (err) {
				this.error = err.toString()
			} else {
				this.metadata = post
			}
			//console.log(JSON.stringify(post));
		},

		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},

		initload(){
			var self = this;
			self.showPreloader = true;
			 if (!self.allowInfinite) return;
			self.allowInfinite = false;
			
			var categieyName = this.$route.params.subcategory;
			//console.log("subsub"+this.$route.params.subsubcategory);
			if(this.$route.params.subsubcategory!=undefined){
				categieyName = this.$route.params.subsubcategory;
			} 
			
			/* self.axios.post(self.urlCreatProductUri, {
                accesskey: self.$root.customer_info.access_key,
                category: this.$route.params.category,
                subcategory: categieyName,
                filter:self.filterQuery,
                page:self.nextPage,
                sortby:self.sortby,
			}).then(function (response) {
				console.log(response);
				
			
			}).catch(function (error) {
				alert(error);
			}); */
			
			self.axios.post(self.pageurl, {
                accesskey: self.$root.customer_info.access_key,
                category: this.$route.params.category,
                subcategory: categieyName,
                filter:self.filterQuery,
                page:self.nextPage,
                sortby:self.sortby,
			}).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					/*self.category_info = response.data.result.category_info;
					self.category_type = response.data.result.category_info.category_type;
					self.category_name = response.data.result.category_info.title;
					  self.breadcrumbItems[1] = {
						text: response.data.result.category_info.title,
						active: true,
					  };*/
					self.filterTabsOptions.length == 0 && self.filters(response.data.result.filter);
					//if(response.data.result.category_info.category_type=='PRODUCT'){
					
						/* for Pagiation */
						self.nextPage 		= response.data.result.pagination.next;
						self.paginationData = response.data.result.pagination;
						self.currentPage 	= self.paginationData.current>0?self.paginationData.current+1:0;
						self.totalProduct 	= response.data.result.totalProduct;
					
						/* For Web & Mobile View */
						if(self.thisisweb==1){
							self.products=response.data.result.products;
							self.showPreloader = false;
							self.allowInfinite = true;
						
						}else{
							for(let p of response.data.result.products){
								self.products.push(p);
							}
							//console.log("countProduct"+response.data.result.products.length);	
						 if (typeof(self.nextPage)== "undefined"){
								self.showPreloader = false;
								self.allowInfinite = false;
								return;
							}else{
								self.showPreloader = false;
								self.allowInfinite = true;
							}
							
						
						}
						
					//}
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			}).catch(function (error) {
				alert(error);
			});
		},

    filterProductsLoad(){
			//console.log('Load me Vijay1');
			var self = this;
		  self.products = [];
		  self.paginationData =[];
		  self.currentPage = 0;
		  self.totalProduct=0;
		  self.nextPage = 0;
		  /*if (!self.allowInfinite) return;
			self.allowInfinite = false;*/
		  if(self.products.length==0){
			self.allowInfinite= false;
			self.showPreloader= true;
		  }
		
			var categieyName = this.$route.params.subcategory;
			//console.log("subsub"+this.$route.params.subsubcategory);
			if(this.$route.params.subsubcategory!=undefined){
				categieyName = this.$route.params.subsubcategory;
			} 
			self.axios.post(self.pageurl, {
                accesskey: self.$root.customer_info.access_key,
                category: this.$route.params.category,
                subcategory: categieyName,
                filter: self.filterQuery,
                page:self.nextPage,
				sortby:self.sortby,
			}).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					/*self.category_info 	= response.data.result.category_info;
					self.category_type 	= response.data.result.category_info.category_type;*/
					self.filtersAfterclick(response.data.result.filter);
					//if(response.data.result.category_info.category_type=='PRODUCT'){
						/* for Pagiation */
						self.nextPage 		= response.data.result.pagination.next;
						self.paginationData = response.data.result.pagination;
						self.currentPage 	= self.paginationData.current>0?self.paginationData.current+1:0;
						self.totalProduct 	= response.data.result.totalProduct;
					
						/* For Web & Mobile View */
						if(self.thisisweb==1){
							self.products=response.data.result.products;
							self.showPreloader = false;
							self.allowInfinite = true;
						
						}else{
							for(let p of response.data.result.products){
								self.products.push(p);
							}
							//console.log("countProduct"+response.data.result.products.length);	
						 if (typeof(self.nextPage)== "undefined"){
								self.showPreloader = false;
								self.allowInfinite = false;
								return;
							}else{
								self.showPreloader = false;
								self.allowInfinite = true;
							}
							
						
						}
					
						
					//}
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			}).catch(function (error) {
				alert(error);
			});
		},

    loadMore(){
      this.initload();
    }, 
	loadmoredata(){
      this.initload();
    },
    applyFilter(){
		this.showPreloader =false;
		this.filterQuery = [];
      for(let filterTab of this.filterTabsOptions){
        //console.log(filterTab.label);
        this.filterQuery.push({[filterTab.label] : filterTab.selectedOptions});
      }
      this.filterProductsLoad();
    },
    filters(filter) {
      this.filterTabsOptions = [];
	   
	  if (typeof(filter.category_filter)!= "undefined"){
		  if(filter.category_filter.length>0){
			var filterOptions = [];

			for(let filter of filter.category_filter){
			  filterOptions.push({ text: filter.title+" ("+filter.count+")", value: filter.id })
			}

			this.filterTabsOptions.push({
			  label: "Category",
			  isOpened: true,
			  showMinusSign: true,
			  this: this,
			  toggleIcon() {
				this.showMinusSign = !this.showMinusSign;
			  },
			  filterOptions: filterOptions,
			  selectedOptions: [],
			});
		  }
	  }
	  
	  if (typeof(filter.gender_filter)!= "undefined"){
	  
		if(filter.gender_filter.length>0){
			var filterOptionsGender = [];

			for(let filter of filter.gender_filter){
			  filterOptionsGender.push({ text: filter.gender+" ("+filter.count+")", value: filter.gender })
			}

				this.filterTabsOptions.push({
				  label: "Gender",
				  isOpened: false,
				  showMinusSign: false,
				  this: this,
				  toggleIcon() {
					this.showMinusSign = !this.showMinusSign;
				  },
				  filterOptions: filterOptionsGender,
				  selectedOptions: [],
				});
		  }
	   }
	  
	   if (typeof(filter.brand_filter)!= "undefined"){
		  if(filter.brand_filter.length>0){
			var filterOptionsBrand = [];

			for(let filter of filter.brand_filter){
			  filterOptionsBrand.push({ text: filter.brand+" ("+filter.count+")", value: filter.brand })
			}

				this.filterTabsOptions.push({
				  label: "Brand",
				  isOpened: true,
				  showMinusSign: true,
				  this: this,
				  toggleIcon() {
					this.showMinusSign = !this.showMinusSign;
				  },
				  filterOptions: filterOptionsBrand,
				  selectedOptions: [],
				});
		  } 
	  }
	  
	 


      /*if(filter.price_filter){
        filterOptions = { min: filter.price_filter[0].min, max: filter.price_filter[0].max };
        this.filterTabsOptions.push({
          label: "Price",
          isOpened: false,
          showMinusSign: false,
          this: this,
          toggleIcon() {
            this.showMinusSign = !this.showMinusSign;
          },
          filterOptions: filterOptions,
          selectedOptions: '',
        });
      } */
	  if (typeof(filter.price_filter)!= "undefined"){
	  if(filter.price_filter.length>0){	
		
		var filterOptionsPrice = [];
		var filterPF = filter.price_filter[0];
		for(var key in filterPF) {
		  //console.log("Key: " + key + " value: " + filterPF[key]);
		 if(key!='4000 & Above'){
		 var opTextAr = key.split('-');
		 var opText= 'Rs.'+opTextAr[0]+' - Rs.'+opTextAr[1];
		 }else{
		   opText= 'Rs.'+key;
		 }
		 
		 if(filterPF[key]>0){
		  filterOptionsPrice.push({ text: opText+" ("+filterPF[key]+")", value:key});
		  }
		}		
        this.filterTabsOptions.push({
          label: "Price",
          isOpened: false,
          showMinusSign: false,
          this: this,
          toggleIcon() {
            this.showMinusSign = !this.showMinusSign;
          },
          filterOptions: filterOptionsPrice,
          selectedOptions: [],
        });
      }
	  }
	  
	  /* if(filter.discount_filter.length>0){
	 
        var filterOptionsDiscount = [];

        for(let filter of filter.discount_filter){
          filterOptionsDiscount.push({ text: filter.discount+"% ("+filter.count+")", value: filter.discount})
        }

			this.filterTabsOptions.push({
			  label: "Discount",
			  isOpened: false,
			  showMinusSign: false,
			  this: this,
			  toggleIcon() {
				this.showMinusSign = !this.showMinusSign;
			  },
			  filterOptions: filterOptionsDiscount,
			  selectedOptions: [],
			});
		
      }*/
	  if (typeof(filter.discount_filter)!= "undefined"){
	  if(filter.discount_filter.length>0){	
		
		var filterOptionsDiscount = [];
		var filterDF = filter.discount_filter[0];
		for(var keyDf in filterDF) {
		 
		  var opTextD= keyDf;
		  var optionVal = this.discountArry[keyDf];
		 // console.log('optionVal:'+optionVal);
		if(filterDF[keyDf]>0){
			filterOptionsDiscount.push({ text: opTextD+" ("+filterDF[keyDf]+")", value:optionVal});
		  }
		}		
        this.filterTabsOptions.push({
          label: "Discount",
          isOpened: false,
          showMinusSign: false,
          this: this,
          toggleIcon() {
            this.showMinusSign = !this.showMinusSign;
          },
          filterOptions: filterOptionsDiscount,
          selectedOptions: [],
        });
      }
	  }
	  
	  
	  
     // console.log('dddd'+this.filterTabsOptions);
    },
	addtofavouriteNotlogin(){
			if(this.$root.customer_info.access_key == ''){
				this.$router.push({
					name: 'Login',
					params: {
						redirect: '/category/'+this.$route.params.category
					}
				});
			}
		},
		handleScroll(event){	

		if (!this.allowInfinite){
			this.showPreloader=false;
			return;
		} 

		//this.showPreloader=true;
		if(!this.showPreloader){
				console.log(event);
				 var listElm = document.getElementById("infinite-list")
				 // console.log(listElm.scrollTop+'---'+listElm.clientHeight+'---'+listElm.scrollHeight);
				  if(listElm.scrollTop + listElm.clientHeight >=listElm.scrollHeight) {
					//var self = this;
					 this.loading = true;
					  setTimeout(this.loadmoredata(),5000);	
						/* setTimeout(e => {
							this.loadmoredata();
							this.showPreloader = false;
						  }, 200); */
					//console.log(e); addEventListener
				  }
			}
		},
	  filtersAfterclick(filter) {
			//console.log('logG');
			//console.log('JsonFilter'+JSON.parse(this.filterTabsOptions));
			var fl=this.filterTabsOptions;
			
			//console.log('BF'+fl.brand_filter);
			
			fl.forEach((value, index) => {
				/*if(value.label=='Brand'){
					console.log('BF'+value);
					console.log('BFindex'+index);
					this.filterTabsOptions.splice(index);
				}*/
				if(value.label=='Gender'){
					//fl.splice(index);
					//this.filterTabsOptions.splice(index, 1);
					this.filterTabsOptions[index].filterOptions=[];
					var filterOptionsGender = [];
					for(let filter of filter.gender_filter){
					  filterOptionsGender.push({ text: filter.gender+" ("+filter.count+")", value: filter.gender })
					}
					this.filterTabsOptions[index].filterOptions=filterOptionsGender;
					
				}
				if(value.label=='Brand'){
					//fl.splice(index);
					//this.filterTabsOptions.splice(index, 1);
					this.filterTabsOptions[index].filterOptions=[];
					var filterOptionsBrand = [];
					for(let filter of filter.brand_filter){
					  filterOptionsBrand.push({ text: filter.brand+" ("+filter.count+")", value: filter.brand })
					}
					this.filterTabsOptions[index].filterOptions=filterOptionsBrand;
					
				}
				
				
				if(value.label=='Price'){
					this.filterTabsOptions[index].filterOptions=[];
					 //if(filter.price_filter.length>0){	
		
							var filterOptionsPrice = [];
							var filterPF = filter.price_filter[0];
							for(var key in filterPF) {
							  //console.log("Key: " + key + " value: " + filterPF[key]);
							 if(key!='4000 & Above'){
							 var opTextAr = key.split('-');
							 var opText= 'Rs.'+opTextAr[0]+' - Rs.'+opTextAr[1];
							 }else{
							   opText= 'Rs.'+key;
							 }
							 
							 if(filterPF[key]>0){
								filterOptionsPrice.push({ text: opText+" ("+filterPF[key]+")", value:key});
							  }
							}		
							
							this.filterTabsOptions[index].filterOptions=filterOptionsPrice;
				}
				
				/* if(value.label=='Discount'){
					//fl.splice(index);
					//this.filterTabsOptions.splice(index, 1);
					this.filterTabsOptions[index].filterOptions=[];
					var filterOptionsDiscount = [];

					for(let filter of filter.discount_filter){
					  filterOptionsDiscount.push({ text: filter.discount+"% ("+filter.count+")", value: filter.discount})
					}
					this.filterTabsOptions[index].filterOptions=filterOptionsDiscount;
					
				} */
				
				if(value.label=='Discount'){
					this.filterTabsOptions[index].filterOptions=[];
						//if(filter.discount_filter.length>0){	
							var filterOptionsDiscount = [];
							var filterDF = filter.discount_filter[0];
							for(var keyDf in filterDF) {
							 var opTextDf= keyDf;
							 var optionVal = this.discountArry[keyDf];
							// console.log('optionVal 111:'+optionVal);
							if(filterDF[keyDf]>0){
							  filterOptionsDiscount.push({ text: opTextDf+" ("+filterDF[keyDf]+")", value:optionVal});
							  }
							}	
							this.filterTabsOptions[index].filterOptions=filterOptionsDiscount;
				}
				 
				
				
				
			
			});
			
		  
		  //console.log(this.filterTabsOptions);
		},
		applyShorting() {
				  this.nextPage = 0;
				  this.products = [];
				  this.loadMore();
			 
		},
		handlePageChange(value) {
			//this.page = value;
				console.log('pagNo'+value+'CurretPage:'+this.currentPage);
		  
			  if(this.currentPage!=value){
				  this.nextPage = value-1;
				  this.loadMore();
			  }
		},
		

	},
  metaInfo() {
        //console.log('-------META INFO-------');
		//console.log('dev'+JSON.stringify(this.metaInfoList[this.$route.params.category]));
		let titleMeta = 'Alluraa';
		let descriptionMeta ='Alluraa';
		if(this.metaInfoList[this.$route.params.category]){
		let getTitle = this.metaInfoList[this.$route.params.category].title;
		let getdescription = this.metaInfoList[this.$route.params.category].description;
		 undefined
			if(getTitle){
				titleMeta = getTitle;
			}
			if(getdescription){
				descriptionMeta = getdescription;
			}
		}
		
		 if (typeof(this.category_info.meta_keywords)!= "undefined" && this.category_info.meta_keywords!=null){
			titleMeta = this.category_info.meta_keywords;
			
		 }
		 if (typeof(this.category_info.meta_description)!= "undefined" && this.category_info.meta_description!=null){
			descriptionMeta = this.category_info.meta_description;
		 }
		
		
		
		return{
			
			title: titleMeta,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				/* { name: 'keywords', content: this.metadata.keywords }, */
				{ name: 'description', content: descriptionMeta},
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' },
				{ name:'p:domain_verify', content: '2414d644d27428df1547004055b7bcb0' }
				
				
			]
		}
	}
};
</script>

<style scoped lang="scss">

</style>